/**
 * SpeedDial modules
 */
export * from './speed-dial';
